"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63],{

/***/ 1065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 5 modules
var slicedToArray = __webpack_require__(7113);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3091);
;// CONCATENATED MODULE: ./src/constants/index.ts
/* provided dependency */ var process = __webpack_require__(4406);
var isProd = process.env.NEXT_PUBLIC_ENV === "production";
var isStaging = process.env.NEXT_PUBLIC_ENV === "staging";
var isDevelopment = process.env.NEXT_PUBLIC_ENV === "development";
var isTest = process.env.NEXT_PUBLIC_ENV === "test";
var rCmpEbi = (/* unused pure expression or super */ null && (["function name() view returns (string)", "function symbol() view returns (string)", "function totalSupply() view returns (uint256)", "function balanceOf(address) view returns (uint)", "function getPricePerFullShare() external view returns (uint256)", "function underlyingBalanceInPool() external view returns (uint256)", "function deposit(uint256 assets, address receiver) external returns (uint256 shares)", "function approve(address spender, uint256 value) external returns (bool)", "function registerQSRP(address qsrp, bool status) external", "function returnInvestment(address qsrp, uint amount) external", "function scheduleWithdraw(uint256 assets) external", "function scheduleEmergencyWithdraw(uint256[] depositIds) external", "function updateDepositFeeNominator(uint16 depositFeeNominator) external", "function updateGlobalWithdrawTimelock(uint globalTimelock) external", "function updateInvestmentAllowance(bool isInvestmentAllowed) external", "function updateInvestmentBalance(address qsrp, uint amount, uint realEventTime) external", "function updateTreasuryAddress(address treasuryAddress) external", "function updateWithdrawFee(uint newFee) external", "function updateWithdrawWaitingPeriod(uint withdrawWaitingPeriod) external", "function withdraw(uint256 assets, address receiver, address owner) external returns (uint256 shares)", "function withdrawInvestmentToQSRP(address qsrp, uint amount) external"]));
;// CONCATENATED MODULE: ./src/utils/image.ts
/* provided dependency */ var image_process = __webpack_require__(4406);

var getSrc = function getSrc(src) {
  return (isProd || isStaging ? image_process.env.NEXT_PUBLIC_CDN_URL : "") + src;
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/components/Image/Image.tsx






var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Image__Wrapper",
  componentId: "sc-ejlq9j-0"
})(["position:relative;width:", "px;height:", "px;transition:opacity ", "s;@media (max-width:", "){width:", "px;height:", "px;}"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var _ref3$fadeInDuration = _ref3.fadeInDuration,
      fadeInDuration = _ref3$fadeInDuration === void 0 ? 0.25 : _ref3$fadeInDuration;
  return fadeInDuration;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.mobile;
}, function (_ref5) {
  var width = _ref5.width,
      mobileWidth = _ref5.mobileWidth;
  return mobileWidth || width;
}, function (_ref6) {
  var height = _ref6.height,
      mobileHeight = _ref6.mobileHeight;
  return mobileHeight || height;
});
var Image = /*#__PURE__*/react.forwardRef(function (_ref7, ref) {
  var src = _ref7.src,
      width = _ref7.width,
      height = _ref7.height,
      alt = _ref7.alt,
      mobileWidth = _ref7.mobileWidth,
      mobileHeight = _ref7.mobileHeight,
      _ref7$quality = _ref7.quality,
      quality = _ref7$quality === void 0 ? 100 : _ref7$quality,
      _ref7$layout = _ref7.layout,
      layout = _ref7$layout === void 0 ? "intrinsic" : _ref7$layout,
      _ref7$objectFit = _ref7.objectFit,
      objectFit = _ref7$objectFit === void 0 ? "contain" : _ref7$objectFit,
      _ref7$objectPosition = _ref7.objectPosition,
      objectPosition = _ref7$objectPosition === void 0 ? "center" : _ref7$objectPosition,
      _ref7$loading = _ref7.loading,
      loading = _ref7$loading === void 0 ? "lazy" : _ref7$loading,
      _ref7$priority = _ref7.priority,
      priority = _ref7$priority === void 0 ? false : _ref7$priority,
      sizes = _ref7.sizes,
      className = _ref7.className,
      _ref7$fadeInDuration = _ref7.fadeInDuration,
      fadeInDuration = _ref7$fadeInDuration === void 0 ? 0.25 : _ref7$fadeInDuration,
      onClick = _ref7.onClick;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      opacity = _React$useState2[0],
      setOpacity = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    className: className,
    width: width,
    height: height,
    mobileWidth: mobileWidth,
    mobileHeight: mobileHeight,
    ref: ref,
    onClick: onClick,
    style: {
      opacity: opacity
    },
    fadeInDuration: fadeInDuration,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: getSrc(src),
      layout: layout,
      width: layout === "fill" ? undefined : width,
      height: layout === "fill" ? undefined : height,
      objectFit: objectFit,
      objectPosition: objectPosition,
      quality: quality,
      sizes: sizes,
      alt: alt,
      priority: priority,
      loading: priority ? undefined : loading,
      onLoadingComplete: function onLoadingComplete() {
        return setOpacity(1);
      }
    })
  });
});
/* harmony default export */ var Image_Image = (Image);
;// CONCATENATED MODULE: ./src/components/Image/index.ts


/***/ }),

/***/ 7978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3091);

var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "Section",
  componentId: "sc-wr30e2-0"
})(["max-width:1280px;width:100%;position:relative;z-index:2;padding:0 56px;margin:0 auto;@media (max-width:", "){padding:0 48px;}@media (max-width:", "){padding:0 24px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.tablet;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});

/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* reexport safe */ _Section__WEBPACK_IMPORTED_MODULE_0__.$; }
/* harmony export */ });
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7978);


/***/ }),

/***/ 2573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Overlay; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3091);
;// CONCATENATED MODULE: ./src/components/Overlay/Overlay.tsx

var Overlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Overlay",
  componentId: "sc-1plkbhl-0"
})(["width:100%;height:100%;position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);z-index:11;"]);
;// CONCATENATED MODULE: ./src/components/Overlay/index.ts


/***/ }),

/***/ 9025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ Page_Page; }
});

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3091);
// EXTERNAL MODULE: ../../packages/ui/index.ts + 101 modules
var ui = __webpack_require__(6226);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 3 modules
var components_Image = __webpack_require__(1065);
;// CONCATENATED MODULE: ./src/routes/index.ts
var routes = {
  home: "/",
  about: "/about-us",
  contact: "/contact",
  joinAsSyndicate: "/contact/join-as-syndicate",
  becomeAnAuditor: "/contact/become-an-auditor",
  submitAProgram: "/contact/submit-a-program",
  privacy: "/privacy-policy",
  terms: "/terms",
  faq: "/faq",
  careers: "/careers",
  claims: "/claims",
  download: "/download",
  download_ios: "/download/ios",
  download_android: "/download/android",
  agents: "/for-agents",
  licenses: "/licenses",
  blog: "/blog",
  insurance: "/insurance",
  calculator: "/calculator",
  apiAccess: "/api-access",
  whitepaper: "https://files.coverre.com/docs/Re-Whitepaper.pdf"
};
;// CONCATENATED MODULE: ./src/routes/external.ts
var external_routes = {
  careers: "https://jobs.lever.co/cover-2",
  appStore: "https://apps.apple.com/US/app/id1021671617",
  playStore: "https://play.google.com/store/apps/details?id=com.cover.android",
  googlePrivacy: "https://policies.google.com/privacy",
  googleTerms: "https://policies.google.com/terms",
  plaidLegal: "https://plaid.com/legal",
  stripePrivacy: "https://stripe.com/us/privacy",
  stripeLegal: "https://stripe.com/us/checkout/legal",
  instagram: "https://www.instagram.com/usecover/",
  facebook: "https://www.facebook.com/cover",
  twitter: "https://twitter.com/cover",
  linkedin: "https://www.linkedin.com/company/cover-./mycompany"
};
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/components/Link/Link.tsx


var _excluded = (/* unused pure expression or super */ null && (["newTab"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ExternalLink = styled_components_browser_esm["default"].a.withConfig({
  displayName: "Link__ExternalLink",
  componentId: "sc-1mzmt8w-0"
})(["position:relative;white-space:nowrap;&:after{content:\"\";width:100%;position:absolute;left:0;bottom:-2px;color:", ";border-width:0 0 1px;border-style:solid;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.white.main;
}); // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var Link = function Link(_ref2) {
  var newTab = _ref2.newTab,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(NextLink, _objectSpread(_objectSpread({}, props), {}, {
    passHref: true,
    children: /*#__PURE__*/_jsx(ExternalLink, _objectSpread(_objectSpread({}, newTab && {
      target: "_blank",
      rel: "noopener noreferrer"
    }), {}, {
      children: props.children
    }))
  }));
}; // export const Link = NextLink;
;// CONCATENATED MODULE: ./src/components/Link/UnstyledLink.tsx


var UnstyledLinkStyle = (0,styled_components_browser_esm.css)(["color:inherit;text-decoration:inherit;font-weight:inherit;"]);
var UnstyledLink = (0,styled_components_browser_esm["default"])((link_default())).withConfig({
  displayName: "UnstyledLink",
  componentId: "sc-1gnnspi-0"
})(["", ""], UnstyledLinkStyle);
var ExternalUnstyledLink = styled_components_browser_esm["default"].a.withConfig({
  displayName: "UnstyledLink__ExternalUnstyledLink",
  componentId: "sc-1gnnspi-1"
})(["", ""], UnstyledLinkStyle);
;// CONCATENATED MODULE: ./src/components/Link/index.ts


// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(2927);
;// CONCATENATED MODULE: ./src/components/Footer/components/index.tsx






var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Wrapper",
  componentId: "sc-wppfln-0"
})(["display:flex;align-items:center;box-sizing:border-box;height:120px;width:100%;padding:32px 0;position:relative;z-index:2;overflow:hidden;background-color:", ";border-radius:60px 60px 0 0;margin-top:auto;@media (max-width:", "){padding:24px 0px;height:auto;border-radius:32px 32px 0 0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.black.tint;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});
var Section = (0,styled_components_browser_esm["default"])(Layout/* Section */.$).withConfig({
  displayName: "components__Section",
  componentId: "sc-wppfln-1"
})([""]);
var Row = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Row",
  componentId: "sc-wppfln-2"
})(["display:flex;justify-content:space-between;@media (max-width:", "){flex-direction:column;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.tablet;
});
var BottomRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__BottomRow",
  componentId: "sc-wppfln-3"
})(["display:flex;padding-top:48px;@media (max-width:", "){flex-direction:column-reverse;align-items:center;}@media (max-width:", "){text-align:center;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.tablet;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.tablet;
});
var LogoSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__LogoSection",
  componentId: "sc-wppfln-4"
})(["width:20%;margin-top:32px;@media (max-width:", "){display:none;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.mobile;
});
var LogoSectionBottom = (0,styled_components_browser_esm["default"])(LogoSection).withConfig({
  displayName: "components__LogoSectionBottom",
  componentId: "sc-wppfln-5"
})(["@media (max-width:", "){display:none;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.tablet;
});
var MiddleSection = (0,styled_components_browser_esm.css)(["width:40%;min-width:275px;margin:0 16px;@media (max-width:", "){width:100%;margin:48px 0;}@media (max-width:", "){margin:0;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.tablet;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.mobile;
});
var ItemsSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__ItemsSection",
  componentId: "sc-wppfln-6"
})(["", " height:320px;display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-start;justify-content:space-between;@media (max-width:", "){width:100%;max-width:500px;justify-content:flex-start;align-content:space-between;}"], MiddleSection, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.tablet;
});
var DownloadSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__DownloadSection",
  componentId: "sc-wppfln-7"
})(["width:30%;align-self:center;@media (max-width:", "){width:100%;align-self:flex-start;}@media (max-width:", "){width:100%;margin-top:64px;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.tablet;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.mobile;
});
var ItemSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__ItemSection",
  componentId: "sc-wppfln-8"
})(["width:196px;display:flex;flex-direction:column;@media (max-width:", "){margin-right:36px;}@media (max-width:", "){width:164px;margin-right:8px;}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.tablet;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.mobile;
});
var Heading = (0,styled_components_browser_esm["default"])(ui/* Heading.H3 */.X6.H3).withConfig({
  displayName: "components__Heading",
  componentId: "sc-wppfln-9"
})(["font-style:italic;font-size:12px;color:", ";margin-top:24px;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.white.main;
});
var components_Link = (0,styled_components_browser_esm["default"])(ui/* Link */.rU).withConfig({
  displayName: "components__Link",
  componentId: "sc-wppfln-10"
})(["margin:4px 0;"]);
var Item = (0,styled_components_browser_esm["default"])(ui/* Text.Body */.xv.uT).withConfig({
  displayName: "components__Item",
  componentId: "sc-wppfln-11"
})(["color:", ";display:block;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.palette.white.main;
});
var Download = (0,styled_components_browser_esm["default"])(ui/* Heading.H4 */.X6.H4).withConfig({
  displayName: "components__Download",
  componentId: "sc-wppfln-12"
})(["color:", ";margin-bottom:32px;@media (max-width:", "){font-size:24px;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.white.main;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoints.tablet;
});
var StoreRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__StoreRow",
  componentId: "sc-wppfln-13"
})(["display:flex;flex-direction:row;flex-wrap:wrap;"]);
var GooglePlayStore = (0,styled_components_browser_esm["default"])(ExternalUnstyledLink).withConfig({
  displayName: "components__GooglePlayStore",
  componentId: "sc-wppfln-14"
})(["margin-right:22px;margin-bottom:8px;"]);
var AppleAppStore = (0,styled_components_browser_esm["default"])(ExternalUnstyledLink).withConfig({
  displayName: "components__AppleAppStore",
  componentId: "sc-wppfln-15"
})(["margin-bottom:8px;"]);
var Copyright = (0,styled_components_browser_esm["default"])(ui/* Text.Caption */.xv.YS).withConfig({
  displayName: "components__Copyright",
  componentId: "sc-wppfln-16"
})(["", " font-size:14px;letter-spacing:-0.16px;color:", ";display:inline-flex;align-items:center;@media (max-width:", "){display:inline-block;margin-top:64px;}"], MiddleSection, function (_ref19) {
  var theme = _ref19.theme;
  return theme.palette.white.main;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.breakpoints.mobile;
});
var Icons = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Icons",
  componentId: "sc-wppfln-17"
})(["display:none;max-width:168px;justify-content:space-between;@media (max-width:", "){margin:0 auto;width:100%;}"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.breakpoints.mobile;
});
var SocialIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__SocialIcon",
  componentId: "sc-wppfln-18"
})(["width:24px;height:24px;"]);

var _CoverIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components___CoverIcon",
  componentId: "sc-wppfln-19"
})(["display:none;width:48px;height:48px;position:relative;@media (max-width:", "){display:flex;justify-content:center;align-items:center;}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.breakpoints.mobile;
});

var CoverIcon = function CoverIcon() {
  return /*#__PURE__*/_jsx(_CoverIcon, {
    children: /*#__PURE__*/_jsx(Image, {
      src: "/assets/common/icon.svg",
      width: 48,
      height: 48,
      alt: "Cover icon",
      priority: true
    })
  });
};
var NavItem = (0,styled_components_browser_esm["default"])(ui/* Text.Large */.xv.ig).withConfig({
  displayName: "components__NavItem",
  componentId: "sc-wppfln-20"
})(["color:", ";font-weight:700;padding:0 0.25em;line-height:56px;box-sizing:border-box;cursor:pointer;position:relative;font-family:", ";font-size:18px;line-height:24px;"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.palette.white.main;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.fonts.secondary;
});
;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx











var Logo = (0,styled_components_browser_esm["default"])(ui/* Logo */.TR).withConfig({
  displayName: "Footer__Logo",
  componentId: "sc-1ipthmd-0"
})(["cursor:pointer;@media (max-width:", "){justify-self:center;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.mobile;
});
var Footer_routes = [{
  name: "Whitepaper",
  href: routes.whitepaper
}, {
  name: "Contact",
  href: routes.contact
}, {
  name: "FAQ",
  href: routes.faq
}];
var socialMedia = [{
  icon: "/assets/footer/twitter.svg",
  href: external_routes.twitter,
  alt: "Cover Twitter"
}, {
  icon: "/assets/footer/discord.svg",
  href: external_routes.instagram,
  alt: "Cover Discord"
}, {
  icon: "/assets/footer/youtube.svg",
  href: external_routes.facebook,
  alt: "Cover YouTube"
}, {
  icon: "/assets/footer/medium.svg",
  href: external_routes.linkedin,
  alt: "Cover Medium"
}];
var Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Footer__Nav",
  componentId: "sc-1ipthmd-1"
})(["display:grid;grid-template-columns:168px 1fr 168px;justify-content:space-between;align-items:center;width:100%;@media (max-width:", "){grid-template-columns:1fr;grid-template-rows:repeat(3,min-content);grid-gap:36px;text-align:center;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});
var NavLinksStyles = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Footer__NavLinksStyles",
  componentId: "sc-1ipthmd-2"
})(["display:grid;grid-template-columns:repeat(3,min-content);justify-content:center;grid-gap:64px;@media (max-width:", "){grid-gap:48px;}@media (max-width:", "){grid-template-columns:1fr;grid-gap:16px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.tablet;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.mobile;
});
var NavLinks = /*#__PURE__*/react.memo(function () {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavLinksStyles, {
    children: Footer_routes.map(function (route) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UnstyledLink, {
        href: route.href,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          children: route.name
        })
      }, route.href);
    })
  });
});
var SocialIcons = /*#__PURE__*/react.memo(function () {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icons, {
    children: socialMedia.map(function (media) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ExternalUnstyledLink, {
        href: media.href,
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcon, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Image/* Image */.E, {
            src: media.icon,
            width: 24,
            height: 24,
            alt: media.alt,
            priority: true
          })
        })
      }, media.icon);
    })
  });
});

var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Nav, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnstyledLink, {
          href: routes.home,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavLinks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcons, {})]
      })
    })
  });
};

/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ./src/components/Footer/index.ts

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 5 modules
var slicedToArray = __webpack_require__(7113);
// EXTERNAL MODULE: ../../node_modules/@web3-onboard/react/dist/index.js + 141 modules
var dist = __webpack_require__(6039);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(715);
// EXTERNAL MODULE: ./src/utils/blocknative.ts + 8 modules
var blocknative = __webpack_require__(2965);
;// CONCATENATED MODULE: ./src/components/Header/action.ts
var Action;

(function (Action) {
  Action["SetScrollTop"] = "SET_SCROLL_TOP";
  Action["ToggleMenu"] = "TOGGLE_MENU";
})(Action || (Action = {}));

var setScrollTop = function setScrollTop(scrollTop) {
  return {
    type: Action.SetScrollTop,
    payload: scrollTop
  };
};
var toggleMenu = function toggleMenu() {
  return {
    type: Action.ToggleMenu,
    payload: undefined
  };
};
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 179 modules
var motion = __webpack_require__(9652);
// EXTERNAL MODULE: ./src/components/Layout/Section.tsx
var Layout_Section = __webpack_require__(7978);
// EXTERNAL MODULE: ./src/components/Overlay/index.ts + 1 modules
var Overlay = __webpack_require__(2573);
;// CONCATENATED MODULE: ./src/components/Header/components/CloseIcon.tsx




var CloseIcon = function CloseIcon(_ref) {
  var color = _ref.color,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: "Icons/close-blue"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "Symbols",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        id: "Icons/close-blue",
        stroke: color,
        strokeWidth: "2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("line", {
          x1: "2.5",
          y1: "2.5",
          x2: "21.5",
          y2: "21.5",
          id: "Line-4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
          x1: "2.5",
          y1: "21.5",
          x2: "21.5",
          y2: "2.5",
          id: "Line"
        })]
      })
    })]
  });
};

/* harmony default export */ var components_CloseIcon = (CloseIcon);
;// CONCATENATED MODULE: ./src/components/Header/components/LetterLogo.tsx




var LetterLogo = function LetterLogo(_ref) {
  var color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: "Path"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "Home-page",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        id: "Mobile-Nav-Menu",
        transform: "translate(-19.000000, -16.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "Mobile/header/menu",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M34.8155708,24.3644752 C27.7361654,24.7185698 28.9604834,32.5467128 28.9604834,32.5467128 C29.4422383,36.3713956 32.3965462,38.8904268 36.6480617,39.0380623 C40.340377,39.1707036 43.3857969,37.9607843 44.9005345,37.0542099 L48.8399913,44.8973472 C46.6601358,46.2202999 41.5612783,48 36.1253063,48 C25.3000573,48 19.0725494,40.72203 19.0725494,31.5224913 C19.0725494,22.8477509 25.8854521,16 35.5319392,16 C43.201295,16 46.3401047,17.1856978 46.3697162,17.1972318 L46.3697162,17.1972318 L46.3697162,30.094579 C45.87885,30.2099193 45.1681761,30.3333333 44.7160327,30.3979239 C38.9566129,31.2226067 36.563783,27.9354095 36.4601431,24.3690888 C35.9124228,24.3379556 35.363453,24.3364156 34.8155708,24.3644752 L34.8155708,24.3644752 Z",
            id: "Path"
          })
        })
      })
    })]
  });
};

/* harmony default export */ var components_LetterLogo = (LetterLogo);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ./src/components/Header/components/Logo.tsx


function Logo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Logo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Logo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Logo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Logo_objectSpread(Logo_objectSpread({
    width: 30,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.359 4.406c-.538-.074-1.746-.173-1.746 3.124L5.565 16H0V.312L5.108.294v1.99C6.324-.08 9.918-.467 12 .475v6.683c-.226.052-.639.129-.847.158-2.75.387-3.831-1.23-3.794-2.91Zm14.877-.53c-1.619 0-2.719.898-3.033 2.391h6.066c-.262-1.56-1.373-2.392-3.033-2.392ZM22.126 0C26.943 0 30 3.464 30 7.787V9.4l-10.798-.014c.098 1.221 1.471 2.438 3.908 2.438 1.893 0 3.277-.52 3.944-1.048l1.887 3.672c-1.118.664-3.49 1.553-6.275 1.553C16.932 16 14 12.332 14 7.787 14 3.488 17.185 0 22.125 0Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ var components_Logo = (SvgLogo);
;// CONCATENATED MODULE: ./src/components/Header/components/MenuIcon.tsx




var MenuIcon = function MenuIcon(_ref) {
  var color = _ref.color,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: "Menu Icon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4 12H20",
      stroke: color || "white",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4 18H20",
      stroke: color || "white",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4 6H20",
      stroke: color || "white",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};

/* harmony default export */ var components_MenuIcon = (MenuIcon);
;// CONCATENATED MODULE: ./src/components/Header/components/index.tsx









var components_Overlay = (0,styled_components_browser_esm["default"])(Overlay/* Overlay */.a).withConfig({
  displayName: "components__Overlay",
  componentId: "sc-j0wtnn-0"
})(["@media (min-width:", "){display:none;}@media (max-width:", "){display:none;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.tablet;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});
var Container = (0,motion/* motion */.E)(styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Container",
  componentId: "sc-j0wtnn-1"
})(["position:absolute;width:100%;height:110px;z-index:11;border-radius:0 0 60px 60px;display:flex;justify-content:center;align-items:center;box-shadow:", ";@supports (backdrop-filter:blur(48px)) or (-webkit-backdrop-filter:blur(48px)){background-image:", ";-webkit-backdrop-filter:", ";backdrop-filter:", ";background-color:", " !important;}@media (max-width:", "){height:64px;border-radius:0px 0px 32px 32px;}"], function (_ref3) {
  var sticky = _ref3.sticky;
  return sticky ? "0px 2px 12px 0px rgba(0, 0, 0, 0.1)" : "none";
}, function (_ref4) {
  var sticky = _ref4.sticky;
  return sticky && "linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), rgba(0, 0, 0, 0.6)";
}, function (_ref5) {
  var sticky = _ref5.sticky;
  return sticky && "blur(48px)";
}, function (_ref6) {
  var sticky = _ref6.sticky;
  return sticky && "blur(48px)";
}, function (_ref7) {
  var sticky = _ref7.sticky;
  return sticky ? "transparent" : "rgba(0, 0, 0, 1)";
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.mobile;
}));
var components_Section = (0,styled_components_browser_esm["default"])(Layout_Section/* Section */.$).withConfig({
  displayName: "components__Section",
  componentId: "sc-j0wtnn-2"
})(["margin:16px auto;@media (max-width:", "){padding:0 56px;}@media (max-width:", "){padding:0 24px;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.tablet;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.mobile;
});
var components_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Wrapper",
  componentId: "sc-j0wtnn-3"
})(["display:flex;justify-content:space-between;.wallet-button{&:disabled svg circle{fill:currentColor;}}"]);
var components_Nav = styled_components_browser_esm["default"].nav.withConfig({
  displayName: "components__Nav",
  componentId: "sc-j0wtnn-4"
})(["display:grid;grid-template-columns:1fr min-content 1fr;justify-content:space-between;align-items:center;width:100%;@media (max-width:", "){grid-template-columns:unset;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.mobile;
});
var Header_components_Logo = (0,styled_components_browser_esm["default"])(components_Logo).withConfig({
  displayName: "components__Logo",
  componentId: "sc-j0wtnn-5"
})(["cursor:pointer;@media (max-width:", "){display:", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.mobile;
}, function (_ref13) {
  var sticky = _ref13.sticky;
  return sticky ? "none" : "inline-block";
});
var Header_components_LetterLogo = (0,styled_components_browser_esm["default"])(components_LetterLogo).withConfig({
  displayName: "components__LetterLogo",
  componentId: "sc-j0wtnn-6"
})(["display:none;cursor:pointer;@media (max-width:", "){display:", ";}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.mobile;
}, function (_ref15) {
  var sticky = _ref15.sticky;
  return sticky ? "inline-block" : "none";
});
var components_NavItem = (0,styled_components_browser_esm["default"])(ui/* Text.Large */.xv.ig).withConfig({
  displayName: "components__NavItem",
  componentId: "sc-j0wtnn-7"
})(["font-family:", ";font-weight:700;color:", ";padding:0 0.25em;box-sizing:border-box;cursor:pointer;position:relative;font-size:18px;line-height:24px;border:1px solid ", ";", " @media (max-width:", "){display:none;}&:hover,&:active,&:focus{border-bottom-color:", ";}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fonts.secondary;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.white.main;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.palette.black.main + theme.opacity.none;
}, function (_ref19) {
  var active = _ref19.active;
  return active && (0,styled_components_browser_esm.css)(["border-bottom-color:", ";"], function (_ref20) {
    var theme = _ref20.theme;
    return theme.palette.mint.main;
  });
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.breakpoints.mobile;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.palette.mint.main;
});
var GetAppButton = (0,styled_components_browser_esm["default"])(ui/* SecondaryButton */.kq).withConfig({
  displayName: "components__GetAppButton",
  componentId: "sc-j0wtnn-8"
})(["box-shadow:none;padding:0;justify-self:end;@media (max-width:", "){margin-left:0;visibility:", ";display:", ";line-height:16px;}&:hover,&:active,&:focus{background-color:transparent;color:", ";border:none;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.breakpoints.mobile;
}, function (_ref24) {
  var $scrollUp = _ref24.$scrollUp;
  return $scrollUp && "hidden";
}, function (_ref25) {
  var $sticky = _ref25.$sticky,
      $scrollUp = _ref25.$scrollUp;
  return !$scrollUp && $sticky ? "block" : "none";
}, function (_ref26) {
  var theme = _ref26.theme,
      disabled = _ref26.disabled;
  return !disabled && theme.palette.white.main;
});
var Menu = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Menu",
  componentId: "sc-j0wtnn-9"
})(["display:none;box-sizing:border-box;@media (max-width:", "){width:100%;", " justify-content:center;background-color:", ";opacity:", ";position:fixed;top:0;padding-top:64px;z-index:-10;display:", ";grid-gap:24px;align-items:center;box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.breakpoints.tablet;
}, function (_ref28) {
  var open = _ref28.open,
      isMobile = _ref28.isMobile,
      sticky = _ref28.sticky;

  if (open && isMobile && !sticky) {
    return (0,styled_components_browser_esm.css)(["height:calc(100vh - calc(100vh - 100%));"]);
  } else if (open && (!isMobile || sticky)) {
    return (0,styled_components_browser_esm.css)(["height:100vh;"]);
  } else {
    return (0,styled_components_browser_esm.css)(["height:0;"]);
  }
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.palette.black.main;
}, function (_ref30) {
  var open = _ref30.open;
  return open ? 1 : 0;
}, function (_ref31) {
  var open = _ref31.open;
  return open ? "grid" : "none";
});
var NavButton = (0,styled_components_browser_esm.css)(["display:none;width:32px;height:32px;align-self:center;cursor:pointer;"]);
var CloseButton = (0,styled_components_browser_esm["default"])(components_CloseIcon).withConfig({
  displayName: "components__CloseButton",
  componentId: "sc-j0wtnn-10"
})(["", " width:24px;height:24px;@media (max-width:", "){display:", ";}"], NavButton, function (_ref32) {
  var theme = _ref32.theme;
  return theme.breakpoints.tablet;
}, function (_ref33) {
  var menuOpen = _ref33.menuOpen;
  return menuOpen && "inline-block";
});
var MenuButton = (0,styled_components_browser_esm["default"])(components_MenuIcon).withConfig({
  displayName: "components__MenuButton",
  componentId: "sc-j0wtnn-11"
})(["", " width:24px;height:24px;@media (max-width:", "){display:", ";}"], NavButton, function (_ref34) {
  var theme = _ref34.theme;
  return theme.breakpoints.tablet;
}, function (_ref35) {
  var menuOpen = _ref35.menuOpen;
  return !menuOpen && "inline-block";
});
var MenuItem = (0,styled_components_browser_esm["default"])(ui/* Text.Body */.xv.uT).withConfig({
  displayName: "components__MenuItem",
  componentId: "sc-j0wtnn-12"
})(["margin:8px 0;font-family:", ";font-size:30px;font-weight:700;line-height:32px;cursor:pointer;"], function (_ref36) {
  var theme = _ref36.theme;
  return theme.fonts.secondary;
});
var Label = (0,styled_components_browser_esm["default"])(ui/* Text.Body */.xv.uT).withConfig({
  displayName: "components__Label",
  componentId: "sc-j0wtnn-13"
})(["font-family:", ";font-size:16px;font-weight:700;line-height:24px;"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.fonts.secondary;
});
var components_Icons = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Icons",
  componentId: "sc-j0wtnn-14"
})(["display:none;align-items:center;padding:20px 24px;height:64px;width:100%;border-radius:32px 32px 0px 0px;justify-content:space-between;margin:auto auto 0;background-color:", ";@media (max-width:", "){display:none;}@media (max-width:", "){}"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.palette.black.tint;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.breakpoints.tablet;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.mobile;
});
var components_SocialIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__SocialIcon",
  componentId: "sc-j0wtnn-15"
})(["width:24px;height:24px;"]);
var MobileNavLinks = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__MobileNavLinks",
  componentId: "sc-j0wtnn-16"
})(["display:grid;grid-gap:24px;text-align:center;margin-top:auto;margin-bottom:auto;"]);
var Actions = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Actions",
  componentId: "sc-j0wtnn-17"
})(["display:grid;grid-auto-flow:column;grid-gap:24px;justify-content:end;align-items:center;@media (max-width:", "){grid-gap:16px;}"], function (_ref41) {
  var theme = _ref41.theme;
  return theme.breakpoints.mobile;
});
var NotificationButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "components__NotificationButton",
  componentId: "sc-j0wtnn-18"
})(["box-sizing:border-box;display:inline-grid;place-items:center;align-self:center;justify-self:center;width:56px;height:56px;aspect-ratio:1;border-radius:48px;background-color:transparent;border:2px solid ", ";color:", ";@media (max-width:", "){width:32px;height:32px;padding:0;}&:hover,&:focus{background-color:", ";border-color:", ";color:", ";}&:focus{border:3px solid ", ";}&:focus-visible{outline-color:", ";}&:disabled{color:", ";border-color:", ";background-color:transparent;cursor:not-allowed;}svg path{fill:currentColor;}"], function (_ref42) {
  var theme = _ref42.theme;
  return theme.palette.white.main;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.palette.white.main;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.breakpoints.tablet;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.palette.mint.tint;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.palette.mint.tint;
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.palette.black.main;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.palette.white.main;
}, function (_ref49) {
  var theme = _ref49.theme;
  return theme.palette.white.main;
}, function (_ref50) {
  var theme = _ref50.theme;
  return "".concat(theme.palette.white.main).concat(theme.opacity.half);
}, function (_ref51) {
  var theme = _ref51.theme;
  return "".concat(theme.palette.white.main).concat(theme.opacity.half);
});
var WalletButton = (0,styled_components_browser_esm["default"])(ui/* SecondaryButton */.kq).withConfig({
  displayName: "components__WalletButton",
  componentId: "sc-j0wtnn-19"
})(["@media (max-width:", "){height:32px;font-size:14px;padding:4px 16px;}&:hover,&:focus{svg{circle{fill:currentColor;}}}"], function (_ref52) {
  var theme = _ref52.theme;
  return theme.breakpoints.tablet;
});
;// CONCATENATED MODULE: ./src/components/Header/reducer.ts


function reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reducer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var reducer = function reducer(state, action) {
  switch (action.type) {
    case Action.SetScrollTop:
      return reducer_objectSpread(reducer_objectSpread({}, state), {}, {
        menuOpen: false,
        scrollTop: action.payload,
        scrollUp: state.scrollTop > action.payload,
        sticky: action.payload > 500
      });

    case Action.ToggleMenu:
      return reducer_objectSpread(reducer_objectSpread({}, state), {}, {
        menuOpen: !state.menuOpen
      });

    default:
      throw new Error("Unhandled type: ".concat(action.type));
  }
};
;// CONCATENATED MODULE: ./src/components/Header/DashboardHeader.tsx





 // import { isMobile } from "react-device-detect";








 // import { initNotify, initWeb3Onboard } from "./services";




var variants = {
  sticky: {
    position: "fixed",
    top: [-110, 0],
    backgroundColor: "#191919",
    delay: 0.5
  },
  initial: {
    top: 0,
    position: "absolute"
  }
};
var DashboardHeader_routes = [{
  name: "Member",
  href: "/"
}, {
  name: "Syndicate",
  href: "/syndicates"
}, {
  name: "Auditor",
  href: "/auditors"
}];
var DashboardHeader_socialMedia = [{
  icon: "/assets/footer/twitter.svg",
  href: external_routes.twitter,
  alt: "Cover Twitter"
}, {
  icon: "/assets/footer/discord.svg",
  href: external_routes.instagram,
  alt: "Cover Discord"
}, {
  icon: "/assets/footer/youtube.svg",
  href: external_routes.facebook,
  alt: "Cover YouTube"
}, {
  icon: "/assets/footer/medium.svg",
  href: external_routes.linkedin,
  alt: "Cover Medium"
}];
var DashboardHeader_Nav = (0,styled_components_browser_esm["default"])(components_Nav).withConfig({
  displayName: "DashboardHeader__Nav",
  componentId: "sc-1lm4sut-0"
})(["grid-template-columns:auto min-content 1fr;grid-gap:64px;@media (max-width:", "){grid-gap:24px;grid-auto-flow:column;grid-template-columns:repeat(2,auto);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.tablet;
});
var DashboardHeader_MobileNavLinks = /*#__PURE__*/react.memo(function () {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MobileNavLinks, {
    children: DashboardHeader_routes.map(function (route) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UnstyledLink, {
        href: route.href,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: route.name
        })
      }, route.href);
    })
  });
});
var DashboardHeader_SocialIcons = /*#__PURE__*/react.memo(function () {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Icons, {
    children: DashboardHeader_socialMedia.map(function (media) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ExternalUnstyledLink, {
        href: media.href,
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_SocialIcon, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: media.icon,
            width: 24,
            height: 24,
            alt: media.alt,
            priority: true
          })
        })
      }, media.icon);
    })
  });
});
var NavMenu = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DashboardHeader__NavMenu",
  componentId: "sc-1lm4sut-1"
})(["display:grid;grid-template-columns:repeat(3,min-content);grid-gap:64px;@media (max-width:", "){grid-gap:48px;display:none;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.tablet;
});
var DashboardHeader_NavLinks = /*#__PURE__*/react.memo(function (_ref3) {
  var sticky = _ref3.sticky;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavMenu, {
    children: DashboardHeader_routes.map(function (route) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UnstyledLink, {
        href: route.href,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_NavItem, {
          active: router.pathname === route.href,
          children: route.name
        })
      }, route.href);
    })
  });
});
var initialState = {
  menuOpen: false,
  scrollTop: 0,
  scrollUp: false,
  sticky: false
};

var DashboardHeader = function DashboardHeader(_ref4) {
  var lightMode = _ref4.lightMode;
  var themeContext = (0,react.useContext)(styled_components_browser_esm.ThemeContext);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useConnectWallet = (0,dist/* useConnectWallet */.Or)(),
      _useConnectWallet2 = (0,slicedToArray/* default */.Z)(_useConnectWallet, 1),
      wallet = _useConnectWallet2[0].wallet;

  var _useState = (0,react.useState)("No wallet connected"),
      truncatedAddress = _useState[0],
      setTruncatedAddress = _useState[1];

  var isMobile = (0,react_responsive.useMediaQuery)({
    query: "(max-width: ".concat(themeContext.breakpoints.tablet, ")")
  });
  var connectedWallets = (0,dist/* useWallets */.rB)();
  var menuOpen = state.menuOpen,
      scrollTop = state.scrollTop,
      scrollUp = state.scrollUp,
      sticky = state.sticky;

  var setAddress = function setAddress() {
    var _connectedWallets$, _connectedWallets$$ac;

    var address = (_connectedWallets$ = connectedWallets[0]) === null || _connectedWallets$ === void 0 ? void 0 : (_connectedWallets$$ac = _connectedWallets$.accounts[0]) === null || _connectedWallets$$ac === void 0 ? void 0 : _connectedWallets$$ac.address;

    if (!address) {
      setTruncatedAddress(isMobile ? "Not connected" : "No wallet connected");
    } else if (isMobile) {
      setTruncatedAddress("..." + address.substring(address.length - 4));
    } else {
      setTruncatedAddress(address.substring(0, 6) + "..." + address.substring(address.length - 4));
    }
  };

  (0,react.useEffect)(function () {
    blocknative/* initWeb3Onboard */.g;
    setAddress();
  }, []);
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll(e) {
      var _e$target, _e$target$documentEle;

      var newScrollTop = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$documentEle = _e$target.documentElement) === null || _e$target$documentEle === void 0 ? void 0 : _e$target$documentEle.scrollTop) || 0;
      dispatch(setScrollTop(newScrollTop));
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollTop]);
  (0,react.useEffect)(function () {
    setAddress();
  }, [isMobile, connectedWallets]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [menuOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Overlay, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      sticky: sticky,
      initial: "initial",
      animate: sticky ? "sticky" : scrollTop < 110 ? "initial" : "hide",
      transition: {
        ease: "easeOut",
        duration: 0.25
      } // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ,
      variants: variants,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Section, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Wrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardHeader_Nav, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnstyledLink, {
              href: "/",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header_components_Logo, {})
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardHeader_NavLinks, {
              sticky: sticky || !lightMode
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Actions, {
              children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
                children: "Avalanche"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(WalletButton, {
                className: "wallet-button",
                disabled: wallet === null,
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Dot */.oT, {}),
                iconPosition: "left",
                children: truncatedAddress
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
                $scrollUp: scrollUp || !sticky,
                menuOpen: menuOpen,
                color: themeContext.palette.white.main,
                onClick: function onClick() {
                  return dispatch(toggleMenu());
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
                $scrollUp: scrollUp || !sticky,
                menuOpen: menuOpen,
                color: themeContext.palette.white.main,
                onClick: function onClick() {
                  return dispatch(toggleMenu());
                }
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Menu, {
        open: menuOpen,
        isMobile: isMobile,
        sticky: sticky,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardHeader_MobileNavLinks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardHeader_SocialIcons, {})]
      })]
    })]
  });
};

/* harmony default export */ var Header_DashboardHeader = (DashboardHeader);
;// CONCATENATED MODULE: ./src/components/Header/index.ts

;// CONCATENATED MODULE: ./src/components/Page/Page.tsx








var Page_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Page__Wrapper",
  componentId: "sc-hbp90n-0"
})(["overflow:hidden;background-color:", ";min-height:100vh;display:flex;flex-direction:column;"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.black.main;
});

var Page = function Page(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      children = _ref2.children;
  var TITLE = "".concat(title, " | Cover Re");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: TITLE
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "title",
        content: TITLE
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://app.coverre.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: TITLE
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "/banner.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:url",
        content: "https://app.coverre.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:title",
        content: TITLE
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:image",
        content: "/banner.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        href: "/favicon.ico"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Page_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header_DashboardHeader, {}), children, /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Footer, {})]
    })]
  });
};

/* harmony default export */ var Page_Page = (Page);
;// CONCATENATED MODULE: ./src/components/Page/index.ts


/***/ }),

/***/ 1115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ PageTemplate_DashboardPageTemplate; }
});

// UNUSED EXPORTS: PageTemplate

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3091);
// EXTERNAL MODULE: ../../packages/ui/index.ts + 101 modules
var ui = __webpack_require__(6226);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(2927);
;// CONCATENATED MODULE: ./src/components/PageTemplate/components/index.tsx



var components_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Wrapper",
  componentId: "sc-uju9uh-0"
})(["padding-top:144px;height:100%;margin-bottom:auto;@media (max-width:", "){padding-top:110px;}@media (max-width:", "){padding-top:64px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.tablet;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});
var components_Section = (0,styled_components_browser_esm["default"])(Layout/* Section */.$).withConfig({
  displayName: "components__Section",
  componentId: "sc-uju9uh-1"
})([""]);
var components_Title = (0,styled_components_browser_esm["default"])(ui/* Heading.H1 */.X6.H1).withConfig({
  displayName: "components__Title",
  componentId: "sc-uju9uh-2"
})(["text-align:", ";font-weight:700;"], function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment || "center";
});
var components_Subtitle = (0,styled_components_browser_esm["default"])(ui/* Text.Large */.xv.ig).withConfig({
  displayName: "components__Subtitle",
  componentId: "sc-uju9uh-3"
})(["margin:0 auto;margin-top:16px;text-align:center;max-width:700px;"]);
var components_BottomCaption = (0,styled_components_browser_esm["default"])(ui/* Text.Caption */.xv.YS).withConfig({
  displayName: "components__BottomCaption",
  componentId: "sc-uju9uh-4"
})(["font-size:16px;line-height:24px;color:", ";margin:48px auto;text-align:center;max-width:55ch;"], function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.palette.white.main).concat(theme.opacity.half);
});
var components_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Content",
  componentId: "sc-uju9uh-5"
})(["margin-top:24px;border-radius:48px;box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);padding-block:24px;padding-inline:", ";@media (max-width:", "){padding:0;margin-top:32px;}"], function (_ref5) {
  var dashboard = _ref5.dashboard;
  return dashboard ? "0" : "128px";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.tablet;
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/components/PageTemplate/DashboardPageTemplate.tsx





var DashboardPageTemplate = function DashboardPageTemplate(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      className = _ref.className,
      bottomCaption = _ref.bottomCaption;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Wrapper, {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Section, {
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Title, {
        alignment: "left",
        children: title
      }), subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Subtitle, {
        children: subtitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Content, {
        dashboard: true,
        children: children
      }), bottomCaption && /*#__PURE__*/(0,jsx_runtime.jsx)(components_BottomCaption, {
        children: bottomCaption
      })]
    })
  });
};

/* harmony default export */ var PageTemplate_DashboardPageTemplate = (DashboardPageTemplate);
;// CONCATENATED MODULE: ./src/components/PageTemplate/PageTemplate.tsx





var PageTemplate = function PageTemplate(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      className = _ref.className,
      bottomCaption = _ref.bottomCaption;
  return /*#__PURE__*/_jsx(Wrapper, {
    className: className,
    children: /*#__PURE__*/_jsxs(Section, {
      children: [title && /*#__PURE__*/_jsx(Title, {
        children: title
      }), subtitle && /*#__PURE__*/_jsx(Subtitle, {
        children: subtitle
      }), /*#__PURE__*/_jsx(Content, {
        children: children
      }), bottomCaption && /*#__PURE__*/_jsx(BottomCaption, {
        children: bottomCaption
      })]
    })
  });
};

/* harmony default export */ var PageTemplate_PageTemplate = ((/* unused pure expression or super */ null && (PageTemplate)));
;// CONCATENATED MODULE: ./src/components/PageTemplate/index.ts



/***/ })

}]);